import React, { useRef, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import { Box, Button } from "../../../components/elements";
import { Breadcrumb } from "../../../components";
import { DeleteToast, SomethingWentWrongToast, Txt } from "../../../components/generalComponets";
import { Post } from "../../../services/services";
import { PageLayout } from "../../../layouts/PageLayout";
import { useNavigate } from "react-router-dom";
import { AskConfirm } from "../../../components/admin/askConfirm";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { store } from "../../../store";
import { AddPlan } from "./AddPlan";
import { PlanCard } from "./PlanCard";
import { SearchPickerHookForm } from "../../../components/SearchPickerHookForm";
import { SearchPicker } from "../../../components/SearchablePicker";
import { ALL_OBJ } from "../../../constants/colors";

const PlanList = (props) => {
  let navigate = useNavigate();
  const childRefPlan = useRef();
  const confirmRef = useRef();

  const [customerType, setCustomerType] = useState(ALL_OBJ);
  const onAddClick = (e) => {
    childRefPlan.current.onShowModal();
  };

  useEffect(() => {
    fetch_data();
  }, []);

  const fetch_data = (post = {}) => {};

  const onDeletePlan = (item) => {
    Post("/plan/delete", { id: item.id }, (status, response) => {
      if (status) {
        if (response.isSuccess) {
          DeleteToast("Plan");
          store.dispatch({ type: "DELETE_PLAN", payload: item.id });
        } else if (response && response.errorMessage) {
          toast(response.errorMessage, { type: "error" });
        } else {
          SomethingWentWrongToast();
        }
      } else {
        SomethingWentWrongToast();
      }
    });
  };

  const handleTypeSelect = (add) => {
    if (add.id !== customerType.id) {
      setCustomerType(add);
      fetch_data({ type_id: add.id });
    }
  };

  return (
    <>
      <PageLayout>
        <Row>
          <Col xl={12}>
            <Box className="mc-card">
              <Breadcrumb title="Plans">
                {props.permissions.plan_add ? (
                  <Button onClick={onAddClick} icon="add" className="mc-btn gray sm m-2" label="asdasd">
                    Add Plan
                  </Button>
                ) : null}
              </Breadcrumb>
            </Box>
          </Col>
          <div>
            <SearchPicker
              list={props.plan.customerTypes}
              value={customerType}
              title="Type"
              field="name"
              value_field="id"
              mt={16}
              AddAll
              style={{ width: 240 }}
              onChange={handleTypeSelect}
              disableLimitedChip
            />
          </div>
          {props.plan.planList.map((item, index) => (
            <Col xl={3} key={index}>
              <PlanCard
                title={item.name}
                description={item.description}
                rate={item.rate}
                type={item.type}
                count={item.count}
                index={index}
                onEdit={props.permissions.plan_edit ? () => childRefPlan.current.onShowModal(item) : null}
                onDelete={props.permissions.plan_delete ? () => confirmRef.current.show_modal(item) : null}
              />
            </Col>
          ))}
        </Row>
      </PageLayout>
      <AddPlan ref={childRefPlan} customer_types={props.plan.customerTypes} onSuccess={fetch_data} />
      <AskConfirm ref={confirmRef} onSubmit={onDeletePlan} />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    plan: state.plan,
    permissions: state.user.permissions,
  };
};

export const ConnectedPlanList = connect(mapStateToProps)(PlanList);
